// Content data for MISFiTS Hostel & Cafe

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/7blpsptj_transparentlogo%20%282%29.jpeg";
export const LOGO_WHITE_URL = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/m2ihk5jg_Logo.png";

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/azrqgcl7_HeroImage.jpg";
export const DORM_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/y16x0lgo_Dorm.jpeg";
export const FOUR_BED_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/8wr9jgk8_4Bed.jpeg";
export const SIX_BED_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/p8koaivr_6Bed.jpeg";
export const EIGHT_BED_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/3p688bik_8Bed.jpeg";
export const HYBRID_ROOM_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/9bjmevp2_HybridRoom.JPG";
export const PRIVATE_ROOM_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/txvz0jjs_PrivateRoom.jpeg";
export const CAFE_IMAGE = "https://customer-assets.emergentagent.com/job_misfits-dorms/artifacts/7qr4idw9_Cafe.png";

export const WHATSAPP_NUMBER = "+918219446375";
export const CALL_NUMBER = "+918219446375";
export const WHATSAPP_LINK = `https://wa.me/918219446375?text=Hi%2C%20I'd%20like%20to%20book%20a%20stay%20at%20Misfits%20Hostel!`;
export const CALL_LINK = `tel:+918219446375`;
export const BOOKING_LINK = "#";

export const HOSTEL_INFO = {
  name: "MISFiTS Hostel & Cafe",
  tagline: "Where the misfits find home.",
  subtitle: "Tucked in the quiet forests of Shoja \u2014 a hostel and cafe for those who travel slower, think deeper, and stay longer.",
  storyTitle: "Built for wanderers.",
  storyText: "MISFiTS started as a crazy idea \u2014 take one of Shoja's most soulful spots and turn it into a place where strangers become friends, and friends become family. We have dorms for the solo traveller chasing the mountains on a budget, private rooms for the couple wanting quiet, and our hybrid room for families who want it all. And then there's the cafe \u2014 because good coffee and mountain views fix most things.",
  location: "Shoja, Himachal Pradesh",
  altitude: "2500m",
  email: "misfitshostelandcafe@gmail.com",
  phone: "+91 8219446375",
  instagram: "https://www.instagram.com/misfitshostelandcafe/",
  address: "MISFiTS Hostel & Cafe, Shoja Village, Seraj Valley, Kullu District, Himachal Pradesh \u2014 175029",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3399.6012567799025!2d77.37200179999999!3d31.562555999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3905afdcaf5d1fe7%3A0x961c392dfb11caed!2sMisfits%20Hostel%20and%20Cafe!5e0!3m2!1sen!2sin!4v1775632726889!5m2!1sen!2sin",
  directions: {
    fromDelhi: "Volvo bus to Aut (12 hrs), then local taxi to Shoja (1.5 hrs)",
    fromManali: "Via Jalori Pass or Aut \u2014 approx 4\u20135 hrs by taxi",
    nearestTown: "Banjar (22 km)"
  },
  highlights: [
    { icon: "mountain", label: "Shoja Valley" },
    { icon: "leaf", label: "2500m Altitude" },
    { icon: "flame", label: "Bonfire Nights" },
    { icon: "coffee", label: "All-day Cafe" }
  ]
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Rooms", href: "/rooms" },
  { label: "Cafe", href: "/cafe" },
  { label: "Gallery", href: "/gallery" },
  { label: "Reviews", href: "/reviews" },
  { label: "Location", href: "/location" }
];

export const ROOMS = [
  {
    id: 1,
    name: "4-Bed Dorm",
    category: "Cosy & Intimate",
    description: "Cosy and intimate. Great for meeting fellow travellers without the chaos. Lockers included, curtained bunks for privacy.",
    capacity: "4 Beds",
    amenities: ["4 Beds", "Lockers", "Shared Bath"],
    image: FOUR_BED_IMAGE,
    images: [FOUR_BED_IMAGE]
  },
  {
    id: 2,
    name: "6-Bed Dorm",
    category: "The Social Hub",
    description: "The social hub of the hostel. Meet your next travel partner over morning chai right here.",
    capacity: "6 Beds",
    amenities: ["6 Beds", "Lockers", "Shared Bath"],
    image: SIX_BED_IMAGE,
    images: [SIX_BED_IMAGE]
  },
  {
    id: 3,
    name: "8-Bed Dorm",
    category: "Budget Friendly",
    description: "Budget-friendly and lively. Perfect when you want to stretch your trip without stretching your wallet.",
    capacity: "8 Beds",
    amenities: ["8 Beds", "Lockers", "Shared Bath"],
    image: EIGHT_BED_IMAGE,
    images: [EIGHT_BED_IMAGE]
  },
  {
    id: 4,
    name: "Private Room",
    category: "Your Own Corner",
    description: "Your own corner of the mountains. A private room with an ensuite bathroom and a view worth waking up for.",
    capacity: "2 Guests",
    amenities: ["Double Bed", "Ensuite Bath", "Mountain View"],
    image: PRIVATE_ROOM_IMAGE,
    images: [PRIVATE_ROOM_IMAGE]
  },
  {
    id: 5,
    name: "Hybrid Room",
    subtitle: "Perfect for Families",
    category: "Family Favourite",
    description: "One double bed. Two bunk beds. Sleeps a family of four comfortably \u2014 everyone gets a bed, no one fights over the window seat.",
    capacity: "Sleeps 4",
    amenities: ["1 Double Bed", "2 Bunk Beds", "Sleeps 4", "Private Bath", "Family Favourite"],
    image: HYBRID_ROOM_IMAGE,
    images: [HYBRID_ROOM_IMAGE]
  }
];

export const CAFE_HIGHLIGHTS = [
  {
    title: "All-day Breakfast",
    description: "Eggs your way, toasts, pancakes, and local specials to start the mountain day right."
  },
  {
    title: "Mountain Chai & Coffee",
    description: "Brewed slow, served hot. Filter coffee, pour-over, masala chai, and more."
  },
  {
    title: "Comfort Plates",
    description: "Dal, rice, pastas, and wraps \u2014 hearty food for tired legs and happy souls."
  },
  {
    title: "Bonfires & Late Nights",
    description: "Evenings around the fire with drinks, music, and strangers who feel like friends."
  }
];

export const CAFE_TEXT = {
  title: "Fuel for the hills.",
  subtitle: "Good coffee, honest food, and enough chai to outlast any drizzle. Open to all \u2014 guests and wanderers alike.",
  bottomTitle: "Open to all \u2014 guests & walk-ins",
  bottomText: "The cafe is the heart of MISFiTS. Whether you're staying with us or just passing through Shoja, you're always welcome to pull up a chair, watch the mountains, and stay a while. We source locally, cook simply, and believe that the best meals are the ones shared with strangers who become friends."
};

export const GALLERY_IMAGES = [
  { src: HERO_IMAGE, alt: "MISFiTS Hostel exterior" },
  { src: FOUR_BED_IMAGE, alt: "4-Bed Dorm" },
  { src: CAFE_IMAGE, alt: "MISFiTS Cafe" },
  { src: PRIVATE_ROOM_IMAGE, alt: "Private Room" },
  { src: SIX_BED_IMAGE, alt: "6-Bed Dorm" },
  { src: EIGHT_BED_IMAGE, alt: "8-Bed Dorm" },
  { src: HYBRID_ROOM_IMAGE, alt: "Hybrid Room" },
  { src: DORM_IMAGE, alt: "Dorm view" }
];

export const REVIEWS = [
  {
    name: "Ananya S.",
    text: "Honestly one of the best stays I've had in Himachal. The vibe is unreal \u2014 warm people, great food, and that bonfire on the last night... I didn't want to leave.",
    context: "Solo Traveller",
    date: "January 2025",
    stars: 5
  },
  {
    name: "Rajesh & Priya M.",
    text: "Brought my family here \u2014 4 of us in the hybrid room. Kids loved the bunk beds, we loved the quiet and the cafe. Perfect mountain getaway.",
    context: "Family Stay",
    date: "December 2024",
    stars: 5
  },
  {
    name: "Karan D.",
    text: "The cafe is genuinely exceptional for a place this remote. Had a pour-over coffee watching the fog roll in over the valley. Can't ask for more.",
    context: "Couple Stay",
    date: "November 2024",
    stars: 4
  },
  {
    name: "Priyanka T.",
    text: "Met the most incredible people in the 6-bed dorm. We ended up trekking together the next morning. This is what hostels are supposed to feel like.",
    context: "Dorm Stay",
    date: "October 2024",
    stars: 5
  },
  {
    name: "Siddharth N.",
    text: "Stayed for 2 nights, extended to 5. The mountains will do that to you. MISFiTS made it very easy to not want to come back.",
    context: "Extended Stay",
    date: "September 2024",
    stars: 5
  },
  {
    name: "Meera & Arjun K.",
    text: "The private room had a stunning view. Woke up to mist over the valley every single morning. Worth every rupee.",
    context: "Private Room",
    date: "August 2024",
    stars: 5
  },
  {
    name: "Tanvir H.",
    text: "The staff made me feel at home from day one. Honestly the warmest hostel I've ever stayed in. Already planning my return trip.",
    context: "Solo Traveller",
    date: "July 2024",
    stars: 5
  },
  {
    name: "Neha R.",
    text: "Came with 6 friends and we took over the 8-bed dorm. Best group trip we've ever had. The bonfire night was absolutely magical.",
    context: "Group Stay",
    date: "June 2024",
    stars: 5
  }
];

export const RATINGS = {
  overall: "4.9",
  cleanliness: "4.8",
  vibe: "5.0",
  staff: "4.9"
};
